import api from './api';

export const getRecipes = () => api.get('/recipes');
export const getRecipe = (id) => api.get(`/recipes/${id}`);
export const createRecipe = (data) => api.post('/recipes', data);
export const updateRecipe = (id, data) => api.put(`/recipes/${id}`, data);
export const deleteRecipe = (id) => api.delete(`/recipes/${id}`);
export const addRecipeItem = (recipeId, materialId, quantity, position = 0) =>
    api.post(`/recipes/${recipeId}/items`, { material_id: materialId, quantity, position });
export const updateRecipeItem = (recipeId, itemId, quantity) =>
    api.put(`/recipes/${recipeId}/items/${itemId}`, { quantity });
export const deleteRecipeItem = (recipeId, itemId) =>
    api.delete(`/recipes/${recipeId}/items/${itemId}`);
export const calculateCost = (items) => api.post('/recipes/calculate', { items });

// ── Nutri-Score ───────────────────────────────────────────────────────────────
export const getNutriScore = (id) => api.get(`/recipes/${id}/nutriscore`);
export const calculateNutriScore = (id, data) => api.post(`/recipes/${id}/nutriscore`, data);
export const sandboxNutriScore = (data) => api.post('/nutriscore/calculate', data);
export const updateNutriScoreLabel = (id, showOnLabel) =>
    api.patch(`/recipes/${id}/nutriscore/label`, { show_on_label: showOnLabel });
export const recalculateAllNutriScores = () => api.post('/nutriscore/recalculate-all');

// ── Printable label ─────────────────────────────────────────────────────────────
export const getRecipeLabel = (id) => api.get(`/recipes/${id}/label`);
export const updateRecipeLabel = (id, data) => api.put(`/recipes/${id}/label`, data);
